module.exports = __webpack_public_path__ + "static/img/2_5@2x.be90d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_5@2x.png
// module id = jd38
// module chunks = 8